import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Columns, Container, Content, Level, Tile } from 'react-bulma-components/full';
import {
  withFaceTracker,
  RealtimeTryon,
  DrawFacePoints,
  DrawBlush,
  DrawEarrings,
  DrawGlasses,
  DrawLipstick,
  fitWebcam,
} from '@facecake/fmt-react-tryon/';

import blushes from '../products/blushes';
import earrings from '../products/earrings';
import glasses from '../products/glasses';
import lipsticks from '../products/lipsticks';

// NOTE: need to pass unique instanceId especially if multiple instances
var uniqid = require('uniqid');

class TryOnPage extends Component {
  constructor(props) {
    super(props);
    // set webcam based on screen orientation
    // screen orientation is in state so it's reactive
    this.fittedWebcam = fitWebcam();
    // default for tutorial setTimeout()
    this.tutorialTimeout = null;
    this.lastBlushColor = null;
    this.state = {
      webcamWidth: this.fittedWebcam.width,
      webcamHeight: this.fittedWebcam.height,
      facePointsVisible: false,
      blushVisible: this.props.productType === 'blush',
      blushAlpha: 0.5,
      currentBlushIndex: 0,
      currentBlushShape: null,
      showBlushTutorial: false,
      earringsVisible: this.props.productType === 'earrings',
      currentEarringsIndex: 0,
      glassesVisible: this.props.productType === 'glasses',
      currentGlassesIndex: 0,
      lipstickVisible: this.props.productType === 'lipstick',
      lipstickAlpha: 0.5,
      currentLipstickIndex: 0,
      currentProducts: blushes,
      currentProductIndex: 0,
    }
  }

  componentDidMount() {
    // NOTE: render on mount into HTML elelment in parent to preven rerendering on state change
    const RealtimeTryonWithFaceTracker = withFaceTracker(RealtimeTryon);
    const instanceId = uniqid();
    const getFacePointsDrawState = () => ({ visible: this.state.facePointsVisible });
    const getBlushDrawState = () => ({ visible: this.state.blushVisible, alpha: this.state.blushAlpha });
    const getLipstickDrawState = () => ({ visible: this.state.lipstickVisible, alpha: this.state.lipstickAlpha });
    const getGlassesDrawState = () => ({ visible: this.state.glassesVisible });
    const getEarringsDrawState = () => ({ visible: this.state.earringsVisible });
    const onGetFaceShape = (faceShape) => {
      console.log(faceShape);
      switch (faceShape) {
        case 'Oval':
        case 'Round':
          this.changeBlushShape('kidneyBean');
          break;
        case 'Heart':
        case 'Square':
          this.changeBlushShape('rightAngle');
          break;
        case 'Long':
          this.changeBlushShape('hotSpot');
          break;
        default:
      }
    };

    ReactDOM.render((
      <div style={{ position: 'relative', minWidth: `${this.state.webcamWidth}px`, minHeight: `${this.state.webcamHeight}px`, display: 'block' }}>
        <RealtimeTryonWithFaceTracker instanceId={`fmt-try-on-${instanceId}`} getFaceShape onGetFaceShape={onGetFaceShape}>
          <DrawFacePoints getDrawState={getFacePointsDrawState} />
          <DrawBlush getCurrentProduct={this.getCurrentBlush} getDrawState={getBlushDrawState} />
         </RealtimeTryonWithFaceTracker>
      </div>
    ), document.getElementById('try-on-container'));
}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.productType !== this.props.productType) {
      let currentProducts;
      switch (this.props.productType) {
        case 'blush':
          currentProducts = blushes;
          break;
        case 'earrings':
          currentProducts = earrings;
          break;
        case 'glasses':
          currentProducts = glasses;
          break;
        case 'lipstick':
          currentProducts = lipsticks;
          break;
        default:
          currentProducts = [];
      }
      this.setState({
        blushVisible: this.props.productType === 'blush',
        earringsVisible: this.props.productType === 'earrings',
        glassesVisible: this.props.productType === 'glasses',
        lipstickVisible: this.props.productType === 'lipstick',
        currentProducts,
        currentProductIndex: 0,
      });
    }
  }

  changeBlushShape = (blushShape) => {
    this.setState({currentBlushShape: blushShape, showBlushTutorial: true, blushAlpha: 1});
    // first clear tutorialTimeout if it already exists
    if (this.tutorialTimeout) {
      clearTimeout(this.tutorialTimeout);
    }
    // then set
    this.tutorialTimeout = setTimeout(() => {
      this.setState({showBlushTutorial: false, blushAlpha: 0.5});
    }, 2000);
  };

  // getter functions
  getCurrentBlush = () => {
    const thisBlush = blushes[this.state.currentProductIndex].blushProduct;
    
    if (this.state.currentBlushShape) {
      thisBlush.productId = this.state.currentBlushShape + thisBlush.productId;
      thisBlush.blushShape = `https://demos.facecake.com/blushing/images/products/blush/blush_${this.state.currentBlushShape}${this.state.showBlushTutorial ? '_outline' : '_makeup'}.png`;
/*      if (this.state.showBlushTutorial) {
        // HACK: save the last color because it's being overwritten for some reason
        if (thisBlush.colorHex) {
          this.lastBlushColor = blushes[this.state.currentProductIndex].blushProduct;
        }
        thisBlush.colorHex = null;
      } else {
        thisBlush.colorHex = this.lastBlushColor;
      }
*/
    }
    return thisBlush;
  };
  
  render() {
    // NOTE: to preven rerendering, we pass getter functions instead of passing state

    const kidneyBeanButton = `https://demos.facecake.com/blushing/images/ui/blush_shape_kidneyBean${this.state.currentBlushShape === 'kidneyBean' ? '_over' : ''}.png`;
    const hotSpotButton = `https://demos.facecake.com/blushing/images/ui/blush_shape_hotSpot${this.state.currentBlushShape === 'hotSpot' ? '_over' : ''}.png`;
    const rightAngleButton = `https://demos.facecake.com/blushing/images/ui/blush_shape_rightAngle${this.state.currentBlushShape === 'rightAngle' ? '_over' : ''}.png`;

    return (
      <div>
        <Container style={{maxWidth: this.fittedWebcam.width}}>
          <Level style={{marginBottom: '0px', maxWidth: this.fittedWebcam.width}} renderAs="div">
            <Level.Item style={{paddingTop: '14px'}}>
              <img onClick={() => this.changeBlushShape('kidneyBean')} src={kidneyBeanButton} alt="kidneyBeanButton" />
              &nbsp;
              <img onClick={() => this.changeBlushShape('hotSpot')} src={hotSpotButton} alt="hotSpotButton" />
              &nbsp;
              <img onClick={() => this.changeBlushShape('rightAngle')} src={rightAngleButton} alt="rightAngleButton" />
            </Level.Item>
            <Level.Item style={{maxWidth: this.fittedWebcam.width / 2}}>
              <Columns gapless style={{maxWidth: this.fittedWebcam.width / 2, marginTop: '10px'}}>
                {this.state.currentProducts.map((product, index) => (
                  <Columns.Column key={index} size={4}>
                    <Content style={{marginBottom: '0px'}}>
                      { (index < 6) && 
                        <img src={this.state.currentProductIndex === index ? product.productThumb.selected : product.productThumb.unselected} 
                        onClick={() => this.setState({currentProductIndex: index})}
                        style={{margin: "2px", maxWidth: this.fittedWebcam.width / ((this.state.currentProducts.length > 4 ? 4 : this.state.currentProducts.length) + 1)}}
                        alt={`select product ${index}`}
                      />}
                    </Content>
                  </Columns.Column>
                ))}
              </Columns>
            </Level.Item>
          </Level>
        </Container>
      </div>
    );
  }
}

export default TryOnPage;
